module.exports = __webpack_public_path__ + "img/auth_scanbox.d8cb056c.png";